// @flow
import React from "react";
import BrandTypography from "../BrandTypography";

import styles from "./galleryWithMobileCarousel.module.scss";

type Image = {
  url: string,
  title: string,
  href: string
};

type Props = {
  images: [Image],
  linkComponent: (href: string, children: any) => void
};

const GalleryWithMobileCarousel = ({ images, linkComponent }: Props) => {
  return (
    <ul className={styles.container}>
      {images.map(({ url, title, href }) => (
        <li key={url} className={styles.imageContainer}>
          {linkComponent(
            href,
            <>
              <img
                width="200px"
                height="200px"
                src={url}
                alt="Neighbourhood"
                className={styles.image}
                loading="lazy"
              />
              <BrandTypography
                color="primary-inverse"
                className={styles.title}
                bold
              >
                {title}
              </BrandTypography>
            </>
          )}
        </li>
      ))}
    </ul>
  );
};

export default GalleryWithMobileCarousel;
